import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'

const FileDropArea = ({ onFileSelected, isImage, isCsv, footerText }) => {

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            const reader = new FileReader()
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')
            reader.onload = () => {
                onFileSelected(file.name, file.type, reader.result)
            }
            reader.readAsArrayBuffer(file)
        })

    }, [])

    var accept;
    if (isImage)
        accept = { 'image/jpeg': [], 'image/png': [], 'image/webp': [], 'image/heic': [], 'image/jfif': [] }
    if (isCsv)
        accept = { 'text/csv': [], }

    const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: false, accept: accept })

    return (
        <>
            <div style={{
                backgroundColor: 'lightGray',
                border: '2px dashed black',
                padding: '5px',
                color: 'black',
                textAlign: 'center',
                minHeight: 250,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                cursor: 'pointer'
            }}>
                <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <p>Drag or click to select files</p>
                </div>
            </div>
            {footerText && <p>{footerText}</p>}
        </>
    )
}


export default FileDropArea;